import {
	IMobileSdkTestRow,
	TMobileSdkTestsResult
} from 'src/apps/mobile-sdk/types/MobileSdkServiceTypes';
import { returnNonNull } from 'src/common/helpers/ArraysHelper';
import { MOBILE_SDK_TYPES_MAP } from 'src/common/helpers/MobileQueriesHelper';

import { MobileSdkTestsQuery } from '../MobileSdkTests.generated';

export const transformMobileSdkTestsResults = (
	result: MobileSdkTestsQuery
): TMobileSdkTestsResult => {
	const tests = result.msdk_test_runs?.filter(returnNonNull) || [];
	const total = result.total?.[0]?.run_id_count || 0;
	const unfilteredTotal = result.unfiltered_total?.[0]?.run_id_count || 0;

	const transformedRows: IMobileSdkTestRow[] = tests.map((test) => ({
		runId: test.run_id ?? '',
		testName: test.test_name ?? '',
		totalIssues: test.total_issues ?? 0,
		criticalIssues: test.critical_issues ?? 0,
		testDate: test.run_time,
		totalScans: test.total_scans ?? 0,
		labels: test.custom_fields?.flat().filter(Boolean) || [],
		platform: test.os ? [test.os] : [],
		appName: test.app ?? '',
		appVersion: test.app_version ?? '',
		sdkType: MOBILE_SDK_TYPES_MAP[test.sdk_type] ?? '',
		productVersion: test.product_version ?? ''
	}));

	return {
		rows: transformedRows,
		total,
		unfilteredTotal
	};
};
